import React from 'react';

import { UserContext } from 'providers';

export const useUser = () => {
  const { state, ...rest } = React.useContext(UserContext);

  return {
    user: state.user,
    isLoggedIn: state.isLoggedIn,
    isAdmin: state.isAdmin,
    challenges: state.challenges,
    ...rest,
  };
};
